// Libraries
import React from 'react'
import PropTypes from 'prop-types'

// PropTypes and DefaultProps
const propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

const defaultProps = {
  width: '165.788',
}

// Component
function IconEmail({ width }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 165.788 161.469"
      width={width}
    >
      <path
        fill="#0070f2"
        opacity="0.148"
        d="M89.573,0c35.294,0,38.238,8.062,38.238,42.285S94.593,94.327,63.905,104.253,0,76.509,0,42.285,54.279,0,89.573,0Z"
        transform="matrix(0.799, 0.602, -0.602, 0.799, 63.713, 0)"
      />
      <g transform="translate(53.807 31.375) rotate(13)">
        <g transform="translate(0 49.451)">
          <path
            fill="#0056bf"
            d="M2.293,390.773a2.293,2.293,0,0,1-1.621-3.915L17.96,369.569a2.293,2.293,0,0,1,3.243,3.243L3.915,390.1A2.286,2.286,0,0,1,2.293,390.773Zm0,0"
            transform="translate(0 -361.95)"
          />
          <path
            fill="#0056bf"
            d="M93.176,429.268a2.293,2.293,0,0,1-1.621-3.915L101.9,415.012a2.293,2.293,0,0,1,3.243,3.243L94.8,428.6A2.285,2.285,0,0,1,93.176,429.268Zm0,0"
            transform="translate(-76.988 -400.445)"
          />
          <path
            fill="#0056bf"
            d="M2.293,338.384a2.294,2.294,0,0,1-1.621-3.915l10.341-10.341a2.293,2.293,0,1,1,3.243,3.243L3.915,337.712A2.286,2.286,0,0,1,2.293,338.384Zm0,0"
            transform="translate(0 -323.456)"
          />
        </g>
        <path
          fill="#559ff5"
          d="M104.061,23.253,83.271,2.463a8.451,8.451,0,0,0-11.927,0L35.816,37.991a8.444,8.444,0,0,0,0,11.927l20.79,20.79a8.453,8.453,0,0,0,11.927,0l35.528-35.528A8.443,8.443,0,0,0,104.061,23.253Zm0,0"
          transform="translate(-28.251 0)"
        />
        <path
          fill="#3c8eef"
          d="M216.153,23.253l-20.79-20.79a8.451,8.451,0,0,0-11.927,0L165.672,20.227,198.39,52.944l17.764-17.764A8.443,8.443,0,0,0,216.153,23.253Zm0,0"
          transform="translate(-140.343 0)"
        />
        <path
          fill="#fff"
          d="M35.809,45.859a2.293,2.293,0,0,1-.447-4.542l32.77-6.554,6.554-32.77a2.293,2.293,0,0,1,4.5.9L72.33,37.16a2.294,2.294,0,0,1-1.8,1.8l-34.27,6.854A2.3,2.3,0,0,1,35.809,45.859Zm0,0"
          transform="translate(-24.346 4.072)"
        />
        <path
          fill="#fff"
          d="M264.124,37.161l6.854-34.27a2.293,2.293,0,0,0-4.5-.9l-6.554,32.771,3.571,3.57A2.291,2.291,0,0,0,264.124,37.161Zm0,0"
          transform="translate(-216.139 4.071)"
        />
      </g>
    </svg>
  )
}

IconEmail.propTypes = propTypes
IconEmail.defaultProps = defaultProps

export default IconEmail
